// REDESIGN 2024

//  import * as Sentry from '@sentry/browser';
import { isMobile } from './../../../utils/viewport.ts';
import { navigationElement } from './../navigationElements.ts';

const LOCAL_STORAGE_MESSAGE_ID = 'breakingNewsClosed';
const DEFAULT_SPACING_FROM_TOP = 24;

export const breakingNews = (template: HTMLTemplateElement) => {
    const bodyElement = document.querySelector('body');
    const brandingWrapperElement: HTMLElement | null = document.querySelector('.branding-wrapper');
    // Vytvořit message
    let message = template.content.firstElementChild?.cloneNode(true) as HTMLDivElement;
    const dynamicNavigation: HTMLElement | null = document.querySelector(
        '[data-dynamic-navigation]',
    );

    // Zjistit, zda je v local storage uloženo, že se nemá zobrazovat
    const messageID: string | null = template.getAttribute('data-breaking-news-template');
    const breakingNewsClosed = localStorage.getItem(`${LOCAL_STORAGE_MESSAGE_ID}-${messageID}`);

    // Pokud byla zpráva zavřená, nezobrazovat
    if (breakingNewsClosed) {
        return;
    }

    handlePosition({
        messageID,
        message,
        dynamicNavigation,
        bodyElement,
        brandingWrapperElement,
        navigationElement,
        scrollTop: 0,
    });

    // Nastavit scroll counter
    let lastScrollPosition = 0;

    window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY; // Aktuální pozice scrollu

        // Zjistit směr scrollovaní
        const isScrollingDown: boolean = scrollTop > lastScrollPosition;

        handlePosition({
            messageID,
            message,
            dynamicNavigation,
            bodyElement,
            brandingWrapperElement,
            navigationElement,
            scrollTop,
            isScrollingDown,
        });

        // Nastavit poslední pozici scrollu při konci eventu
        lastScrollPosition = scrollTop;
    });

    // Při kliknutí na 'křížek' zavřít message
    onCloseRemoveMessage({ message });
};

interface HandlePositionProps {
    messageID: string | null;
    message: HTMLDivElement;
    dynamicNavigation: HTMLElement | null;
    bodyElement: HTMLElement | null;
    brandingWrapperElement: HTMLElement | null;
    navigationElement: HTMLElement | null;
    scrollTop: number;
    isScrollingDown?: boolean;
}

export const handlePosition = ({
    messageID = '0',
    message,
    dynamicNavigation,
    bodyElement,
    brandingWrapperElement,
    navigationElement,
    scrollTop,
    isScrollingDown = false,
}: HandlePositionProps) => {
    const breakingNewsClosed = localStorage.getItem(`${LOCAL_STORAGE_MESSAGE_ID}-${messageID}`);

    if (breakingNewsClosed) {
        return;
    }

    addToDOM({
        bodyElement,
        dynamicNavigation,
        brandingWrapperElement,
        message,
    });

    placeUnderNavigation({
        navigationElement,
        scrollTop,
        isScrollingDown,
    });
};

interface AddToDOMProps {
    bodyElement: HTMLElement | null;
    dynamicNavigation: HTMLElement | null;
    brandingWrapperElement: HTMLElement | null;
    message: HTMLDivElement;
}
export const addToDOM = ({
    bodyElement,
    dynamicNavigation,
    brandingWrapperElement,
    message,
}: AddToDOMProps) => {
    const breakingNewsCloseID = message.getAttribute('data-breaking-news');
    localStorage.getItem(`${LOCAL_STORAGE_MESSAGE_ID}-${breakingNewsCloseID}`);

    // Pokud již je v DOMu, nevkládat znovu
    if (bodyElement?.contains(message)) {
        return;
    }

    // Přidat do DOMu
    // Na mobilu
    if (isMobile()) {

        // Vložit za dynamickou navigaci
        if (dynamicNavigation) {
            dynamicNavigation.after(message);
        } else {
            // Jinak vložit na začátek body
            bodyElement?.prepend(message);
        }

    } else {
        // Na desktopu

        // Pokud je dynamická navigace
        if (dynamicNavigation) {
            // Vložit ihned za ní
            dynamicNavigation.after(message);
        } else {
            // Jinak vložit do 'brandingWrapperu'
            if (brandingWrapperElement) {
                brandingWrapperElement.prepend(message);
                brandingWrapperElement.style.paddingTop = '20px';
            }
        }
    }
};

// Umístit pod navigaci / dynamickou navigaci
interface PlaceUnderNavigationProps {
    navigationElement: HTMLElement | null;
    scrollTop: number;
    isScrollingDown?: boolean;
}

export const placeUnderNavigation = ({
    navigationElement,
    scrollTop = 0,
    isScrollingDown = false,
}: PlaceUnderNavigationProps) => {
    // Výchozí mezera od horního okraje
    let finalTopSpacing = DEFAULT_SPACING_FROM_TOP;

    // Načíst elementy
    const message: HTMLElement | null = document.querySelector('.breaking-news__wrapper');
    const infoStripElement: HTMLElement | null = document.querySelector('[data-info-strip]');
    const dynamicNavigation: HTMLElement | null = document.querySelector(
        '[data-dynamic-navigation]',
    );

    // Zjistit výšku elementů
    const navigationHeight = navigationElement?.clientHeight || 0;
    const dynamicNavigationHeight = dynamicNavigation?.clientHeight || 0;
    const infoStripHeight = infoStripElement?.clientHeight || 0;

    // Přidat výšku navigace
    finalTopSpacing = finalTopSpacing + navigationHeight;

    // Zohlednit infoStrip
    finalTopSpacing = (scrollTop > 0) ? finalTopSpacing - infoStripHeight : finalTopSpacing;

    // Zohlednit dynamickou navigaci
    finalTopSpacing = isScrollingDown ? finalTopSpacing : finalTopSpacing + dynamicNavigationHeight;

    // Korekce pokud vychází odsazení záporné (např. při scrollování nahoru těsně pod navigací)
    if (finalTopSpacing <= navigationHeight + dynamicNavigationHeight + DEFAULT_SPACING_FROM_TOP)
        finalTopSpacing = finalTopSpacing + DEFAULT_SPACING_FROM_TOP

    // Nastavit odsazení
    if (message) {
        message.style.top = `${finalTopSpacing}px`;
        message.style.marginBottom = `${isMobile() ? DEFAULT_SPACING_FROM_TOP : DEFAULT_SPACING_FROM_TOP * 2}px`;
    }
};

// Zavřít message
interface onCloseRemoveMessageProps {
    message: HTMLDivElement;
}

const fadeOut = (element: HTMLElement, duration: number = 300): Promise<void> => {
    return new Promise(resolve => {
        element.style.transition = `opacity ${duration}ms ease-out`;
        element.style.opacity = '0';

        setTimeout(() => {
            resolve();
        }, duration);
    });
};

const onCloseRemoveMessage = async ({ message }: onCloseRemoveMessageProps) => {
    const breakingNewsClose = message.querySelector('[data-breaking-news-close]');
    const breakingNewsCloseID = breakingNewsClose?.getAttribute('data-breaking-news-close');

    if (breakingNewsClose) {
        breakingNewsClose.addEventListener('click', async () => {
            await fadeOut(message);
            message.remove();
            localStorage.setItem(`${LOCAL_STORAGE_MESSAGE_ID}-${breakingNewsCloseID}`, 'true');
        });
    } else {
        // Sentry
        // Sentry.captureMessage('breakingNews: chybí element pro zavření breaking news');
    }
};